'use client';

export default function EcoIconSwiperArrow({ className, ...reset }: { className?: string }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 28 29"
            fill="none"
            className={`bh-icon-arrow${className ? ` ${className}` : ''}`}
            {...reset}
        >
            <path d="M10.5 7.24609L17.5 14.2461L10.5 21.2461" stroke="currentColor" strokeWidth="2.33333" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
